import { isSsr } from './general';

export const getAuthorizationToken = () => (!isSsr ? window.THDCustomer?.default?.token || '' : '');

export const getSvocId = () => (isSsr ? null : window.THDCustomer?.default?.svocID || '');

export const getUserId = () => (isSsr ? null : window.THDCustomer?.default?.userID || '');
